export default __webpack_public_path__ + "static/media/addPhoto.6c8a681b.svg";